import TrackedObject from "./TrackedObject";
import HasID from "./HasID";

export interface CaseWatcher {
    teamId?: number;
    userName?: string;
    teamName?: string;
}

export interface CaseAssignment {
    teamId?: number;
    userName?: string;
    teamName?: string;
}

export interface CaseCategoryPermission {
    id?: number;
    categoryName: string;
    teamId?: number;
    userName?: string;
    teamName?: string;
}

export interface CaseNote extends TrackedObject, HasID {
    patientId: number;
    problem: string;
    categoryName?: string;
    error: boolean;
    resolved: Date;
    resolvedBy: string;
    accepted: Date;
    acceptedBy: string;
    questionSetId?: number;
    storeId?: number;
    prescriberId?: number;
    watchers?: CaseWatcher[];
    assignment?: CaseAssignment;
}

export interface CaseDetail extends CaseNote {
    lastName: string;
    firstName: string;
    middleName: string;
    dateOfBirth: Date;
    addressState?: string;
    phoneNumber: string;
    cellNumber: string;
    storeName?: string;
    prescriptionCount?: number;
    prescriberLastName?: string;
    prescriberFirstName?: string;
    prescriberNPI?: string;
}

export class CaseDetail {
    constructor(obj?: CaseDetail) {
        if (obj) {
            Object.assign(this, obj);
        }
    }
    toString(): string {
        if (this.lastName) {
            return `${this.lastName}, ${this.firstName} ${this.middleName}`;
        }
        return '<div class="font-weight-light">Case</div>';
    }
    getLabel(): string {
        return this.toString();
    }
}
